import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
import ToggleCheckbox from "../../../material/toggleCheckbox/ToggleCheckbox";
import { RedirectCode400 } from "../../../RedirectCode400";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import InputV2 from "../../../material/input/InputV2";
import UploadImage from "../../../material/uploadImage/UploadImage";

function AddBanner() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");

  const [id, setId] = useState(location.state?.id ?? "");
  const [weight, setWeight] = useState(location.state?.weight ?? "");
  const [active, setActive] = useState(location.state?.active ?? true);
  const [imageValue, setImageValue] = useState(location.state?.image ?? "");

  const [defaultOption, setDefaultOption] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (location.state?.type === "banner") {
      setTitlePage("เพิ่มแบนเนอร์");
      setTitleValue(location.state?.type);
    } else if (location.state?.type === "edit-banner") {
      setTitlePage("แก้ไขแบนเนอร์");
      setTitleValue(location.state?.type);
    } else {
      //navigate("/");
    }
  }, []);

  const addBanner = async () => {
    setLoading(true);
    let res = await adminApi.addBanner(imageValue, weight, active);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/banner");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateBanner = async () => {
    setLoading(true);
    let res = await adminApi.updateBanner(id, imageValue, weight, active);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/Banner");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = (type) => {
    // console.log(type);
    if (!imageValue) {
      setIsMessage({ type: "warning", data: "กรุณาอัปโหลดรูปแบนเนอร์" });
    } else if (!weight) {
      setIsMessage({ type: "warning", data: "กรุณากรอกลำดับ" });
    } else if (isNaN(weight) || weight <= 0) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกลำดับเป็นตัวเลขที่ถูกต้อง",
      });
    } else {
      if (type === "banner") {
        addBanner();
      } else {
        updateBanner();
      }
    }
  };

  return (
    <div className="min-w-[376px] overflow-x-auto">
      <PageHeaderV2
        titlename={location.state?.title ? "แก้ไขแบนเนอร์" : titlepage}
      />

      <div className="flex flex-row justify-center items-start md:flex-col w-full gap-[20px]">
        <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px] w-full">
          <div className="md:text-[14px] text-[16px] text-[#000000] md:mt-1 mt-3 font-['Prompt']">
            ไฟล์รูป
          </div>
          <div className="rounded-[6px] border-[#E2E2E4] border w-full p-[9px_16px] mb-[10px]">
            <UploadImage
              title={"รองรับไฟล์ภาพที่มีนามสกุลไฟล์ .Png, Jpeg, Jpg"}
              value={imageValue}
              type={"image"}
              setValue={setImageValue}
              api={adminApi.uploadImageContent}
            />
          </div>
        </div>
        <div>
          <div className="rounded-[6px] border-[#E2E2E4] border p-[9px_16px] ">
            {/* <div className="flex flex-col gap-[8px] font-['Prompt'] text-[16px] mb-[10px]">
                  ปักหมุด
                  <ToggleCheckbox label="" value={pined} setValue={setPined} />
                </div> */}

            <div className="flex flex-col mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              ลำดับ
              <InputV2
                type="text"
                className="border-1 border-solid border-[#E0DFE2] rounded-lg md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
                placeholder=""
                value={weight}
                onChangeEvt={(value) => setWeight(value)}
              />
            </div>

            <div className="flex flex-col gap-[8px] mt-4 font-['Prompt'] text-[16px] mb-[10px]">
              สถานะที่เผยเเพร่
              <ToggleCheckbox label="" value={active} setValue={setActive} />
            </div>
          </div>
          <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
            <button
              onClick={() => {
                navigate("/admin/management/laboratory-inspection-guideline");
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              ยกเลิก
            </button>
            <button
              onClick={() => {
                onClickAddSubmit(location.state?.type);
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBanner;
